import feedBack from "../components/feedBack.vue";

function plugins(Vue) {
	//注册
	Vue.component('feedBack', feedBack);
}
export default plugins;
